import { render, staticRenderFns } from "./purchase-order-drawer.vue?vue&type=template&id=c2f3c2e0&scoped=true"
import script from "./purchase-order-drawer.vue?vue&type=script&lang=js"
export * from "./purchase-order-drawer.vue?vue&type=script&lang=js"
import style0 from "./purchase-order-drawer.vue?vue&type=style&index=0&id=c2f3c2e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2f3c2e0",
  null
  
)

export default component.exports